import "./AlertMessage.scss"

const AlertMessage = ({ message = `` }) => {
  if (!message) {
    return null
  }

  return (
    <div className="AlertMessage" data-testid="alertMessage">
      {message}
    </div>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// AlertMessage.propTypes = {
//   message: PropTypes.string.isRequired,
// }

export default AlertMessage
